/**
 * @prettier
 * @flow
 */
import { cryptoKeys } from 'src/config/cryptoKeys';
import { encryptAsymmetric } from 'src/utils/crypto/encryptAsymmetric';

export function encryptDataInTransit(plaintext: string | {}): string {
    if (plaintext === undefined) {
        throw new Error('plaintext cannot be undefined');
    }
    if (plaintext === null) {
        throw new Error('plaintext cannot be null');
    }

    return encryptAsymmetric(plaintext, cryptoKeys.ENCRYPTION_DATA_IN_TRANSIT_PUBLIC_KEY);
}
